var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleArrowRightSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 18.6281 5.37188 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0C5.37188 0 0 5.37188 0 12ZM13.9219 18.0469C13.4812 18.4875 12.7688 18.4875 12.3328 18.0469C11.8969 17.6063 11.8922 16.8938 12.3328 16.4578L15.6609 13.1297L5.625 13.125C5.00156 13.125 4.5 12.6234 4.5 12C4.5 11.3766 5.00156 10.875 5.625 10.875H15.6609L12.3328 7.54688C11.8922 7.10625 11.8922 6.39375 12.3328 5.95781C12.7734 5.52187 13.4859 5.51719 13.9219 5.95781L19.1719 11.2031C19.6125 11.6438 19.6125 12.3562 19.1719 12.7922L13.9219 18.0469Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowRightSolid);
export default __webpack_public_path__ + "static/media/circle-arrow-right-solid.95fb7e79fc45ba1830e1ed5b2194b425.svg";
export { ForwardRef as ReactComponent };